import { useEffect, useState } from "react"
import GalleriaRow from "./GalleriaRow"

export default function AllGalleriaRows({ obj, id }) {


    const [array, setArray] = useState(false)

    useEffect(() => {
        var galleriaArray = []

        obj.forEach(a => {
            galleriaArray.push(<div className="py-1">
                <h3>
                    {a.title}
                </h3>
                <GalleriaRow item={a.photos} id={id + a.id} smId={a.id} />
            </div>)
        })
        setArray(galleriaArray)
    }, [id, obj])

    return (
        <>
            {array}
        </>
    )
}